export default "__VITE_ASSET__1dG0NqR9__"